export default __webpack_public_path__ + "files/media/hd-membership.e2ca894d.jpg";